import { render, staticRenderFns } from "./Inge.vue?vue&type=template&id=eae2592e&scoped=true"
import script from "./Inge.vue?vue&type=script&lang=ts"
export * from "./Inge.vue?vue&type=script&lang=ts"
import style0 from "./Inge.vue?vue&type=style&index=0&id=eae2592e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae2592e",
  null
  
)

export default component.exports